<style lang="scss" scoped>
.breadcrumbs {
    @apply mb-8 lg:mb-16 flex items-center;

    .breadcrumb {
        @apply text-gray-400 text-14 font-regular whitespace-nowrap;
    }

    .separator {
        @apply px-8 text-gray-400;
    }
}
</style>

<template>
    <div class="breadcrumbs">
        <template v-for="(breadcrumb, index) in breadcrumbs">
            <template v-if="index + 1 < breadcrumbs.length">
                <a class="breadcrumb" :href="breadcrumb.link" :key="index">{{ breadcrumb.title }}</a>
                <span class="separator" :key="`${index}s`" v-html="svg('chevron-right', 'h-8 w-auto mt-4')"></span>
            </template>
            <template v-else>
                <span class="breadcrumb" :key="index">{{ breadcrumb.title }}</span>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    name: "Ui.Breadcrumbs",

    props: {
        breadcrumbs: {
            type: Array,
            required: true
        }
    }
}
</script>